import { createReducer, createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
	setUserData: ['userPayload'],
	getAllClients: null,
	getAllClientsDone:['clientsData'],
	getAllMajors: null,
	getAllMajorsDone: ['majorsData'],
	getUserRequests: ['typeUser', 'userId'],
	getUserRequestDone: ['userRequestData'],
	showAuthMessage: ['message'],
	getDashboard: null,
	getDashboardDone: ['dashboard'],
	getDashboardError: ['errorMessage'],
	editUser: ['user'],
	editUserDone: ['message'],
	editUserError: ['errorMessage'],
	getUsers: null,
	getUsersDone: ['users'],
	getProductsAdmin: null,
	getProductsAdminDone: ['products'],
});

export const INITIAL_STATE = {
	user: null,
	majorUsers: [],
	clientUsers: [],
	dashboard: {},
	clients: [],
	majorists: [],
	products: []
};

export const userTypes = Types;
export default Creators;

const setUserData = (state, { userPayload }) => ({
	...state,
	user: userPayload,
});

const setMajorsUsersData = (state, { majorsData }) => ({
	...state,
	majorUsers: majorsData
});

const setClientsUsersData = (state, { clientsData }) =>({
	...state,
	clientUsers: clientsData
});

const setUserRequestData = (state, { userRequestData }) => ({
	...state,
	userRequests: userRequestData
});

const getDashboardDone = (state, { dashboard }) => ({
	...state,
	dashboard,
	loading: false,
})

const errorMessage = (state, { errorMessage }) => ({
	...state,
	errorMessage,
	loading: false,
})

const fetchRequest = state => ({
	...state,
	loading: true,
	message: '',
})

const showMessage = (state, {message}) => ({
	...state,
	loading: false,
	message,
})

const getUsersDone = (state, {users}) => ({
	...state,
	loading: false,
	majorists: users,
	clients: users,
})

const getProductsAdminDone = (state, {products}) => ({
	...state,
	loading: false,
	products,
})

export const reducer = createReducer(INITIAL_STATE, {
	[Types.SET_USER_DATA]: setUserData,
	[Types.GET_ALL_CLIENTS_DONE]: setClientsUsersData,
	[Types.GET_ALL_MAJORS_DONE]: setMajorsUsersData,
	[Types.GET_USER_REQUEST_DONE]: setUserRequestData,
	[Types.GET_DASHBOARD]: fetchRequest,
	[Types.GET_DASHBOARD_DONE]: getDashboardDone,
	[Types.GET_DASHBOARD_ERROR]: errorMessage,
	[Types.EDIT_USER]: fetchRequest,
	[Types.EDIT_USER_DONE]: showMessage,
	[Types.EDIT_USER_ERROR]: errorMessage,
	[Types.GET_USERS_DONE]: getUsersDone,
	[Types.GET_PRODUCTS_ADMIN_DONE]: getProductsAdminDone,
});